import contentfulGql from 'js/lib/contentfulGql';

import {
  CareerAcademyArticlesCollectionFragment,
  CareerAcademyHeroFragment,
  CareerAcademyTestimonialCarouselFragment,
} from 'bundles/unified-career-academy/queries/contentfulFragments';

export const CareerAcademyPageContentFragmentDoc = contentfulGql`#graphql
  ${CareerAcademyHeroFragment}
  ${CareerAcademyArticlesCollectionFragment}
  ${CareerAcademyTestimonialCarouselFragment}

  fragment CareerAcademyPageContentFields on CareerAcademyPageContent {
    slug
    heroBanner {
      ...CareerAcademyHero
    }
    articles {
      ...CareerAcademyArticlesCollection 
    }
    testimonials {
      ...CareerAcademyTestimonialCarousel
    }
  }
`;

export const contentfulCareerAcademyPageContentQuery = contentfulGql`#graphql
  ${CareerAcademyPageContentFragmentDoc}
  
  query CareerAcademyPageContent($slug: String!, $locale: String!, $preview: Boolean!) {
    careerAcademyPageContentCollection(preview: $preview, locale: $locale, where: { slug: $slug }, limit: 1) {
      items {
        ...CareerAcademyPageContentFields
      }
    }
  }
`;
